import React, { useEffect, useState } from 'react';

import { Box, Button, Typography, Stack } from '@mui/material';
import { useMediaQuery } from '@material-ui/core';
import { Link, useNavigate } from 'react-router-dom';
import "./DashboardNavbar.css";

import Logo from '../../Images/UCFmark-Small_horizontal_WGrgb_72ppi.png'

function DashboardNavBar(props) {
    const navigate = useNavigate();
    const sm = useMediaQuery('(min-width:700px)');

    const logoutUser = () => {
        localStorage.setItem('user', "");
        navigate('/');
    }

    return (
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ background: '#262626', height: 55, px: 1, position: "sticky", top: 0, zIndex: 1251 }}>
            <Stack direction='row' alignItems='flex-end' >
                <img
                    src={Logo}
                    alt='UCF Logo'
                    width='88px'
                />
                <Typography variant='inherit' style={{ color: 'white', marginLeft: "5px", display: sm ? "block" : "none"}}>CECS Sr. Design</Typography>
            </Stack>
            <Stack direction='row' alignItems='center' justifyContent='center' style={{marginLeft: sm ? "-92px" : "10px", marginRight: "10px"}}>
                {props.userType === 'admin' ?
                    <>
                        <Link to='/classselect' className="navbar-link">Home</Link>
                        <Link to='/register' className="navbar-link">Register User</Link>
                        <Link to='/editpublicsite' className="navbar-link">Edit Public Site</Link>
                        {/* <Link href='#' variant='h6' className="navbar-link">Settings</Link> */}
                    </>
                    :
                    <>
                        <Link to='/student' variant='h6' className="navbar-link">Home</Link>
                        <Link to='/team' variant='h6' className="navbar-link">Project Team</Link>
                        {/* <Link href='#' variant='h6' className="navbar-link">Assignments</Link> */}
                    </>
                    
                }
            </Stack>
            <Box>
                {/* Could have this be something else or remove it entirley */}
                <Button variant='outlined' color="error" onClick={logoutUser}>Logout</Button>
            </Box>
        </Stack>
    );
}

export default DashboardNavBar;